import { TOOL, TOOL_LABEL, TOOLS, useImageAnnotatorContext } from "@msuite/image-annotator";
import type { TranslationKey } from "@msuite/utils/locales";
import { getImageAnnotatorToolIcon, Icon } from "../../../icons";
import { useTranslation } from "../../../localization";
import { Tooltip } from "../../../tooltip";
import { cn } from "../../../utils";

export function AnnotationToolbarTools() {
	/** Context */
	const context = useImageAnnotatorContext();

	/** Hooks */
	const { t } = useTranslation();

	/** Functions */
	function handleOnSelectTool(tool: (typeof TOOLS)[number]) {
		const isActive = context.controller.tool === tool;
		context.controller.handleOnChangeTool(isActive ? TOOL.SELECT : tool);
	}

	/** Render */
	return (
		<div className="flex flex-row items-center gap-2 overflow-x-auto">
			{TOOLS.map((tool) => (
				<Tooltip
					key={tool}
					label={t(TOOL_LABEL[tool] as TranslationKey)}
					placement="top"
					zIndexClassName="z-[999999]"
				>
					<button
						type="button"
						onClick={() => handleOnSelectTool(tool)}
						className={cn(
							"flex-center h-9 w-9 shrink-0 rounded-full text-white",
							context.controller.tool === tool ? "bg-primary-700" : "bg-primary-800",
						)}
					>
						<Icon
							name={getImageAnnotatorToolIcon(tool)}
							size={16}
						/>
					</button>
				</Tooltip>
			))}
		</div>
	);
}
